import { render } from "./IndexTwo.vue?vue&type=template&id=3540481b"
import script from "./IndexTwo.vue?vue&type=script&lang=js"
export * from "./IndexTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__